import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Selection } from '../ListItem.types.js';

var _excluded = ["title", "type"];
var useContentSlotListItem = function useContentSlotListItem(_ref) {
  var title = _ref.title,
    type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isCustomSlot = title === undefined;
  var checkmarkIconAssetId = {
    id: 'fill.symbol.check',
    size: '16'
  };
  var subTitle = rest.subTitle,
    leadingAsset = rest.leadingAsset,
    trailingAsset = rest.trailingAsset,
    leadingSlot = rest.leadingSlot,
    contentSlot = rest.contentSlot,
    trailingSlot = rest.trailingSlot,
    disabled = rest.disabled,
    display = rest.display,
    alignItems = rest.alignItems,
    textColor = rest.textColor,
    gap = rest.gap;
  var role = (type === null || type === void 0 ? void 0 : type.type) === 'select' ? 'checkbox' : undefined;
  var isSelected = (type === null || type === void 0 ? void 0 : type.type) === 'select' ? type.selection === Selection.selected : undefined;
  return {
    isSelected: isSelected,
    isCustomSlot: isCustomSlot,
    checkmarkIconAssetId: checkmarkIconAssetId,
    role: role,
    title: title,
    subTitle: subTitle,
    leadingAsset: leadingAsset,
    trailingAsset: trailingAsset,
    leadingSlot: leadingSlot,
    contentSlot: contentSlot,
    trailingSlot: trailingSlot,
    disabled: disabled,
    display: display,
    alignItems: alignItems,
    textColor: textColor,
    gap: gap
  };
};

export { useContentSlotListItem };
//# sourceMappingURL=useContentSlotListItem.js.map
